import React from 'react';
import { AffiliateIcon } from './affiliate-icon';

export const InformerIcon = props => <AffiliateIcon name='info' ariaLabel={props.ariaLabel} {...props} />;
